import { Vehicle } from '@api/index';

import { Attribute, DateRange, Driver, HydratedEntity } from '../../types';

export const DRIVER_SIDEBAR_TYPE = '/driver';

export type BaseSidebarData = {
    id: string;
    level: number;
    childrenIds?: string[];
    vehicles?: Vehicle[];
    drivers?: Driver[];
    children?: HydratedEntity[];
    dateRange?: DateRange;
    attributes?: Attribute[];
};

export type EnrichedSidebarData = BaseSidebarData & {
    childrenIds: string[];
    driverIds: string[];
    electricVehicles: Vehicle[];
    fuelVehicles: Vehicle[];
    electricVehicleIds: string[];
    fuelVehicleIds: string[];
    containsElectricVehicle: boolean;
    containsCombustionVehicle: boolean;
    isVehiclesNameClickable: boolean;
};

export type SidebarData = BaseSidebarData | EnrichedSidebarData;

export type SidebarState = {
    type: string;
    data: SidebarData;
};

export const isEnrichedSidebarData = (data: SidebarData): data is EnrichedSidebarData =>
    data !== null &&
    typeof data === 'object' &&
    'driverIds' in data &&
    'electricVehicles' in data &&
    'fuelVehicles' in data;
